import { generateImageUrl } from '../../../util/helpers'
import { DimensionTypes, Variant } from '../../products/utils/useVariations'
import { CartItem } from '../storage/cart.types'

export const getUpdatedVariant = (variant: Variant, product: CartItem): CartItem => {
  return {
    ...product,
    productId: variant.productId,
    size: variant.dimensions.find((v) => v.type === DimensionTypes.SIZE)?.id,
    sizeDescription: variant.dimensions.find((v) => v.type === DimensionTypes.SIZE)?.value,
    colour: variant.dimensions.find((v) => v.type === DimensionTypes.COLOUR)?.id,
    colourDescription: variant.dimensions.find((v) => v.type === DimensionTypes.COLOUR)?.value,
    imageUrl: generateImageUrl(product.itemNumber),
  }
}
